class editOvatBillRuleCtrl {
    constructor($scope, httpRequest, $location, $stateParams, formvalidateApi) {
        const { ruleSchemaCode } = $stateParams
        // 获取拆合规则信息
        httpRequest.get_qryRuleInfo(ruleSchemaCode).then((res) => {
            $scope.edit = res.data.value
        })
        $scope.editOvatRule = function editOvatRule() {
            const ret = formvalidateApi.run()
            if (ret) {
                httpRequest.post_editorRule($scope.edit, '销售拆合规则修改成功').then((res) => {
                    $location.path('/system/settingcenter/ovatBillRule/list').replace()
                })
            }
        }
        $scope.cancle = function cancle() {
            $location.path('/system/settingcenter/ovatBillRule/list').replace()
        }

        $scope.validateRules = {
            ruleName: [
                {
                    erromsg: '规则名称最长20位',
                    condition(value) {
                        // 规则
                        const result = String(value).length < 21
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
            ruleMark: [
                {
                    erromsg: '规则描述最长100位',
                    condition(value) {
                        // 规则
                        const result = String(value).length < 101
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
        }
    }
}
editOvatBillRuleCtrl.$inject = ['$scope', 'httpRequest', '$location', '$stateParams', 'formvalidateApi']
export default editOvatBillRuleCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/ovatBillRule/editOvatBillRuleCtrl.js